import { FirebaseData } from "../General/FirebaseData";
import { PropertyData } from "../Property/PropertyData";
import { LocalData } from "../General/LocalData";
import { DeviationData } from "../Deviation/DeviationData";
import { DataCreator } from "../../../utils/dataCreator";
import CollectionLoader from "../General/CollectionLoader";
import { ContractorGroupMemberData } from "./ContractorGroupMemberData";
import { FileDocumentData } from "../General/FileDocumentData";
import { arrayRemove, arrayUnion, collection, doc, getFirestore, updateDoc, writeBatch, WriteBatch } from "firebase/firestore";

export class ContractorGroupData extends FirebaseData {
  name: string = "";
  contactEmail: string = "";
  contactPhone: string = "";
  receivesNotifications: boolean = false;
  properties: PropertyData[] = [];

  members: CollectionLoader<ContractorGroupMemberData>;

  constructor(id: string, collection: string, parent?: FirebaseData) {
    super(id, collection, parent);
    this.members = new CollectionLoader<ContractorGroupMemberData>("members", this, ContractorGroupMemberData);
  }

  setup(data: any) {
    this.name = typeof data.name === "string" ? data.name : "";
    this.contactEmail = typeof data.contactEmail === "string" ? data.contactEmail : "";
    this.contactPhone = typeof data.contactPhone === "string" ? data.contactPhone : "";
    this.receivesNotifications = typeof data.receivesNotifications === "boolean" ? data.receivesNotifications : false;

    this.properties = [];
    if (Array.isArray(data.properties)) {
      for (const id of data.properties.filter((id: any) => typeof id === "string")) {
        const property = LocalData.properties.addData(id);
        this.properties.push(property);
      }
    }
    super.setup(data);
  }

  removePropertyFromContractorGroup(property: PropertyData) {
    return super
      .saveUpdate({
        properties: arrayRemove(property.id),
        updatedBy: DataCreator.getUpdatedBy(),
      })
      .then(() => {
        this.properties = this.properties.filter((existingProperties) => existingProperties !== property);
        property.contractors = property.contractors.filter((contractor) => contractor !== this);
        return;
      });
  }

  addProperties(properties: PropertyData[]) {
    return updateDoc(doc(getFirestore(), this.collectionName, this.id), {
      properties: arrayUnion(...properties.map((property) => property.id)),
      updatedBy: DataCreator.getUpdatedBy(),
    }).then(() => {
      this.properties.push(...properties);
      for (const property of properties) {
        property.contractors.push(this);
      }
    });
  }
}
